import { useMemo } from 'react';

/**
 * 返回下拉选项的值
 * @param:dataList数据源
 * @param:valueAttr tea组件下拉框的value值
 * @param:textAttr tea组件下拉框的text值
 * @param:paramArr 更新依赖项
 */
export default function useSelectOption(
  dataList: Array<any>,
  valueAttr: string,
  textAttr: string,
  paramArr: Array<any>,
) {
  const dataArr = useMemo(() => {
    return (
      dataList?.map?.((item) => {
        return {
          value: item?.[valueAttr] || '',
          text: item?.[textAttr] || '',
        };
      }) || [
        {
          value: '',
          text: '',
        },
      ]
    );
  }, paramArr);
  return dataArr;
}

/**
 * mentionsDau的tab展示值
 * @param {object} commonParams 筛选器组件的筛选值
 * @return tab
 */
export const mentionsDauOptions = (commonParams: any) => {
  const mentionsDauOpts = [
    { value: 'mentions', text: 'Mentions', transText: 'Mentions' },
    {
      value: 'mentions_dau',
      text: 'Mentions / DAU',
      transText: 'Mentions / DAU',
    },
  ];
  if (commonParams?.date_type === 'weekly') {
    mentionsDauOpts[1] = {
      value: 'mentions_dau',
      text: 'Mentions / WAU',
      transText: 'Mentions / WAU',
    };
  } else if (commonParams?.date_type === 'monthly') {
    mentionsDauOpts[1] = {
      value: 'mentions_dau',
      text: 'Mentions / MAU',
      transText: 'Mentions / MAU',
    };
  }
  return mentionsDauOpts;
};
